import { Component, input, inject, computed, effect, Signal, signal } from "@angular/core";
import { BaseInfopageComponent } from "../base-infopage/base-infopage.component";
import { KeyInfoComponent } from "./key-info/key-info.component";
import { AccordionStateToolTip, InfoPageAccordionComponent } from "../components/info-page-accordion/info-page-accordion.component";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { BuildingsComponent } from "../components/buildings/buildings.component";
import { StockCoperativeDataService } from "src/services/stockCooperative/stockcoperative-data.service";
import { AccordionIdentity, AccordionStateClass } from "../models/accordion-state.class";
import { ShareSalesComponent } from "../components/share-sales/share-sales.component";
import { UnitSharesComponent } from "../components/unit-shares/unit-shares.component";
import { ImagePackage } from "src/models/common/image.model";
import { PublicAddressInfoComponent } from "../components/public-address-info/public-address-info.component";
import { OrganizationUnitKeyInfo } from "../models/organization-unit-keyinfo.model";

@Component({
    selector: "stock-cooperative",
    templateUrl: "./stock-cooperative.component.html",
    styleUrl: "./stock-cooperative.component.scss",
    imports: [
        BaseInfopageComponent,
        BuildingsComponent,
        KeyInfoComponent,
        InfoPageAccordionComponent,
        EvLogoLoaderComponent,
        ShareSalesComponent,
        PublicAddressInfoComponent,
        UnitSharesComponent
    ],
})
export class StockCooperativeComponent {
    private readonly stockCooperativeDataService = inject(StockCoperativeDataService);

    unitId = input.required<number | undefined>();

    protected readonly buildingAccordionStateClass;
    protected readonly shareSalesAccordionStateClass;
    protected readonly publicAddressInfoAccordionStateClass;
    protected readonly unitSharesAccordionStateClass;

    imagePackages: Signal<ImagePackage[]> = this.stockCooperativeDataService.imagePackages;
    stockCooperativeInfoError = this.stockCooperativeDataService.stockCooperativeInfoError;
    stockCooperativeInfo: Signal<OrganizationUnitKeyInfo> = this.stockCooperativeDataService.stockCooperativeInfo;
    stockCooperativeInfoIsLoading = this.stockCooperativeDataService.stockCooperativeInfoIsLoading;
    loadErrorText = signal("");
    physicalExposures = this.stockCooperativeDataService.physicalExposures;

    private shareSalesAccordionOpened = signal(false);

    staticMapInput = computed(() => {
        if (this.stockCooperativeDataService.position()) {
            return { id: this.unitId(), iconEstateType: "", latlng: this.stockCooperativeDataService.position() };
        }

        return null;
    });

    constructor() {
        effect((): void => {
            this.stockCooperativeDataService.setUnitId(this.unitId());
        });

        this.buildingAccordionStateClass = new AccordionStateClass(
            this.stockCooperativeDataService.propertyInformationResource,
            "Bygninger",
            AccordionIdentity.Buildings,
            "Ingen bygninger registrert for dette aksjelaget",
            "Klarte ikke å laste inn bygninger for aksjelaget",
            (expanded: boolean) => this.onBuildingsAccordionToggled()
        );

        this.publicAddressInfoAccordionStateClass = new AccordionStateClass(
            this.stockCooperativeDataService.publicAddressInfoResource,
            "Adresser",
            AccordionIdentity.PublicAddressInfo,
            "Ingen adresseinformasjon registrert for denne boenheten",
            "Klarte ikke å laste inn adresseinformasjon for boenheten",
            (expanded: boolean) => this.onPublicAddressInfoAccordionToggled(expanded)
            //null,
            //() => this.stockCooperativeInfo()?.dataCounters?.numAddresses ?? null
        );

        const shareSalesTooltip: AccordionStateToolTip = {
            header: "Andelsomsetninger",
            content:
                " Eiendommen er oppdelt i flere boenheter. I tabellen viser vi prisantydninger og salg på enkelte boenheter. Vi vet ikke eksakt hvilken boenhet verdiene gjelder og flere av verdiene kan gjelde samme boenhet.",
        };

        this.shareSalesAccordionStateClass = new AccordionStateClass(
            this.stockCooperativeDataService.unitShareSalesResource,
            "Andelsomsetninger",
            AccordionIdentity.ShareSales,
            "Ingen andelsomsetninger registrert for dette aksjelaget",
            "Klarte ikke å laste inn andelsomsetninger for aksjelaget",
            (expanded: boolean) => this.onShareSalesAccordionToggled(expanded),
            shareSalesTooltip
        );

        this.unitSharesAccordionStateClass = new AccordionStateClass(
            this.stockCooperativeDataService.unitShareInfoResource,
            "Andeler",
            AccordionIdentity.Shares,
            "Ingen andeler registrert for dette aksjelaget",
            "Klarte ikke å laste inn andeler for aksjelaget",
            //(expanded: boolean) => this.onShareSalesAccordionToggled(expanded),
            //shareSalesTooltip
        );
    }

    onBuildingsAccordionToggled(): void {
        this.stockCooperativeDataService.triggerLoadPropertyInformation();
    }
    onShareSalesAccordionToggled(expanded: boolean): void {
        this.shareSalesAccordionOpened.set(expanded);
        //        console.log(this.shareSales());
    }
    onPublicAddressInfoAccordionToggled(expanded: boolean): void {
        this.stockCooperativeDataService.triggerLoadPublicAddressInfo();
    }
}
